import React from 'react';
import PropTypes from 'prop-types';

import Button from '@mui/material/Button';
import {styled} from '@mui/system';

import HotKeyChip from './HotKeyChip';
import Hotkeys from 'react-hot-keys';


const StyledLinkStyleButton = styled(Button)(({ theme }) =>({
    padding: '0 10px 0 10px',
    minWidth: 0,
    minHeight: 0,
    lineHeight: theme.custom.font.line_height,
    fontSize: theme.typography.fontSize
}));


class ActionButton extends React.Component {

    constructor(props) {
        super(props);
    }

    render() {
        const optional_attributes = {};
        if(!this.props.linkStyle){
            optional_attributes.variant = 'contained';
        }
        if(this.props.disabled){
            optional_attributes.disabled = true;
        }
        /*eslint-disable no-unused-vars */
        for(let key in this.props.actionData){
            optional_attributes[`data-${key}`] = this.props.actionData[key];
        }
        /*eslint-enable no-unused-vars */

        let ButtonComponent = Button;
        if(this.props.linkStyle){
            ButtonComponent = StyledLinkStyleButton;
        }
        if(this.props.dataBt){
            optional_attributes["data-bt"] = this.props.dataBt;
        }

        return (
            <span>
                <ButtonComponent
                    size="small"
                    {...optional_attributes}
                    color={this.props.linkStyle ? 'secondary' : 'primary'}
                    onClick={this.props.actionCallback}>
                    {this.props.text}
                    {this.props.hotKey && <HotKeyChip hotKey={this.props.hotKey} />}
                </ButtonComponent>
                {this.props.hotKey && <Hotkeys keyName={this.props.hotKey} onKeyDown={this.props.actionCallback} />}
            </span>
        );
    }
}

ActionButton.propTypes = {
    text: PropTypes.string,
    actionCallback: PropTypes.func,
    actionData: PropTypes.object,
    linkStyle: PropTypes.bool,
    disabled: PropTypes.bool,
    hotKey: PropTypes.string,
    dataBt: PropTypes.string
};

export default ActionButton;
